import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  useGetContactListQuery,
  useUpdateContactListMutation,
} from "@/store/rest_api";
import { Loader2, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import ContactListForm from "@/components/pages/contact-lists/ContactListForm";
import ContactListMembersSection from "@/components/pages/contact-lists/ContactListMembersSection";

export default function EditContactListPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data, isLoading, error } = useGetContactListQuery(id!, {
    skip: !id,
  });

  const [updateList, { isLoading: isUpdating }] =
      useUpdateContactListMutation();

  if (!id) {
    return null;
  }

  if (isLoading) {
    return (
        <div className="flex items-center justify-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
    );
  }

  if (error || !data) {
    return (
        <div className="flex flex-col items-center justify-center h-64 gap-3">
          <p className="text-destructive">Failed to load list</p>
          <Button variant="ghost" onClick={() => navigate("/contacts/lists")}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
        </div>
    );
  }

  const list = data;

  const handleSubmit = async (formData: any) => {
    try {
      await updateList({ id, data: formData }).unwrap();
      toast.success("List updated");
    } catch (e: any) {
      toast.error(e?.detail ?? "Failed to update list");
    }
  };

  return (
      <div className="p-4 max-w-4xl mx-auto space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Edit List</h1>
          <p className="text-muted-foreground">{list.name}</p>
        </div>

        <ContactListForm
            initialData={list}
            onSubmit={handleSubmit}
            isSubmitting={isUpdating}
            submitLabel="Save Changes"
        />

        <ContactListMembersSection listId={id} />
      </div>
  );
}